export const CART_VIEW_PREFERENCE = 'cart.view-preference';

// url paths
export const NUCLEUS_CHECKOUT_SAVED_PAYPAL = '/checkout?savedPaypal=true';
export const SIGN_IN = '/auth/view/checkout/signin';

// Config Switches
export const PAYPAL_CLIENT_ID = 'PAYPAL_CLIENT_ID';
export const PAYPAL_ENABLE = 'PAYPAL_ENABLE';